module.exports = __webpack_public_path__ + "static/media/homeproducts1.49fa198f.png";